export default __webpack_public_path__ + "static/media/PlayStore.0d69ce1c.png";